import { DownArrowIcon } from "assets/icons";
import cn from "classnames";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "ui";

import { ResellerLevel } from "../../constants";
import {
  getResellerLevelLabelIcon,
  getResellerLevelLabelText
} from "../../helpers";
import { ResellerLevelLabelProps } from "./ResellerLevelLabel.types";

import styles from "./ResellerLevelLabel.module.scss";

const ResellerLevelLabel = ({
  level,
  withDropdownArrow = false
}: ResellerLevelLabelProps) => {
  const { t } = useTranslation();

  const LabelIcon = useMemo(() => getResellerLevelLabelIcon(level), [level]);

  const shouldUseBuyerStyles =
    level === ResellerLevel.Buyer || level === ResellerLevel.IncompleteReseller;

  return (
    <div
      className={cn(styles.label, {
        [styles.label__buyer]: shouldUseBuyerStyles,
        [styles.label__beginner]: level === ResellerLevel.BeginnerReseller,
        [styles.label__intermediate]:
          level === ResellerLevel.IntermediateReseller,
        [styles.label__confirmed]: level === ResellerLevel.ConfirmedReseller,
        [styles.label__influencer]: level === ResellerLevel.Influencer
      })}
    >
      {LabelIcon && <Icon as={LabelIcon} />}

      <span
        className={cn(styles.label_text, {
          [styles.label_text__buyer]: shouldUseBuyerStyles,
          [styles.label_text__beginner]:
            level === ResellerLevel.BeginnerReseller,
          [styles.label_text__intermediate]:
            level === ResellerLevel.IntermediateReseller,
          [styles.label_text__confirmed]:
            level === ResellerLevel.ConfirmedReseller,
          [styles.label_text__influencer]: level === ResellerLevel.Influencer
        })}
      >
        {t(getResellerLevelLabelText(level))}
      </span>

      {withDropdownArrow && (
        <Icon
          as={DownArrowIcon}
          className={cn(styles.label_arrow, {
            [styles.label_arrow__buyer]: shouldUseBuyerStyles,
            [styles.label_arrow__beginner]:
              level === ResellerLevel.BeginnerReseller,
            [styles.label_arrow__intermediate]:
              level === ResellerLevel.IntermediateReseller,
            [styles.label_arrow__confirmed]:
              level === ResellerLevel.ConfirmedReseller,
            [styles.label_arrow__influencer]: level === ResellerLevel.Influencer
          })}
        />
      )}
    </div>
  );
};

export default ResellerLevelLabel;
